import { useContext } from 'react';

import { ThemeProviderContext } from '../components/theme/theme-provider-context';

/**
 * A custom hook that returns the appropriate value from the ones provided based
 * on the currently resolved theme of the app.
 *
 * @param light - Value to use when theme is light.
 * @param dark - Value to use when theme is dark.
 *
 * @returns The appropriate value based on the currently resolved theme.
 */
export function useThemeValue<T>(light: T, dark: T): T {
  const { resolvedTheme } = useTheme();

  // If resolvedTheme is not yet loaded (e.g., SSR), you can choose a default
  // For now, we'll assume 'light' if undefined
  if (!resolvedTheme) {
    return light;
  }

  return resolvedTheme === 'dark' ? dark : light;
}

export const useTheme = () => {
  const context = useContext(ThemeProviderContext);
  if (context === undefined) {
    throw new Error('useTheme must be used within a ThemeProvider');
  }
  return context;
};
